import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section aria-labelledby="category-heading" className="border-y border-background-300 bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="reveal mb-9 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-semibold font-label uppercase tracking-widest text-primary-600">
              Case Categories
            </span>
            <h2 id="category-heading" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              按走向查找案例
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            同样是爆料，结局各不相同。先按你最关心的那种走向筛选，再逐条核对时间线。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((item) => {
            const count = articles.filter((article) => article.category === item.key).length;
            return (
              <Link
                key={item.key}
                to={`/archive?category=${item.key}`}
                className="reveal group flex flex-col justify-between rounded-lg border border-background-300 bg-background-50 p-5 transition-colors duration-300 hover:border-primary-300 md:p-6"
              >
                <div>
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className={`${item.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                    {item.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
                <div className="mt-6 flex items-center justify-between border-t border-background-200 pt-4 text-xs font-label text-foreground-500">
                  <span>收录 {count} 条案例</span>
                  <span className="flex items-center gap-1 text-primary-700 transition-all group-hover:gap-2">
                    查看全部
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}